import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { useStore, useStoreActions } from "../../contexts";
import { selectors } from "../../store/state-selectors";
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { routes } from "../../constants";
import OAuthLP from "../../OAuthLP";

// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);
function Logout() {
  const {
    reset
  } = useStoreActions();
  useEffect(() => reset(true), []);
  return /*#__PURE__*/React.createElement(Redirect, {
    to: routes.home
  });
}
export default function MainPages(props) {
  const {
    authorizedPages,
    unauthorizedPages,
    isMobileDevice,
    LoggedOutComponent,
    MobileNotSupportedComponent
  } = props;
  const hasUserInfo = useStore(selectors.user.hasUserInfo);
  const isVendor = useStore(selectors.user.isVendor);
  const {
    logBI
  } = useStoreActions();
  const location = useLocation();
  const [forceShowOnMobile, setForceShowOnMobile] = useState(false);
  const redirectToHome = () => /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: routes.home,
      search: location.search
    }
  });
  return /*#__PURE__*/React.createElement(Switch, null, unauthorizedPages.map(_ref => {
    let {
      url,
      component
    } = _ref;
    return /*#__PURE__*/React.createElement(SentryRoute, {
      path: url,
      key: url,
      component: component
    });
  }), authorizedPages.filter(_ref2 => {
    let {
      vendorOnly
    } = _ref2;
    return !vendorOnly || isVendor;
  }).map(_ref3 => {
    let {
      url,
      component,
      supportsMobile
    } = _ref3;
    return /*#__PURE__*/React.createElement(SentryRoute, {
      path: url,
      key: url,
      render: props => {
        if (!hasUserInfo) {
          return /*#__PURE__*/React.createElement(LoggedOutComponent, null);
        } else if (!supportsMobile && isMobileDevice && !forceShowOnMobile) {
          return /*#__PURE__*/React.createElement(MobileNotSupportedComponent, {
            onProceedAnyway: () => {
              setForceShowOnMobile(true);
              logBI(18200, {
                url: location.pathname,
                isVendor
              });
            }
          });
        } else {
          return /*#__PURE__*/React.createElement(component, props);
        }
      }
    });
  }), /*#__PURE__*/React.createElement(SentryRoute, {
    path: routes.returningOauthFlow,
    component: OAuthLP
  }), /*#__PURE__*/React.createElement(SentryRoute, {
    path: routes.login,
    render: redirectToHome
  }), /*#__PURE__*/React.createElement(SentryRoute, {
    path: routes.logout,
    component: Logout
  }), /*#__PURE__*/React.createElement(SentryRoute, {
    render: redirectToHome
  }));
}